import { useState, useEffect, useRef } from 'react';
import { useGameStore } from '@hollowveil/shared';
import './FPSCounter.css';

export function FPSCounter() {
  const { debugMode } = useGameStore();
  const [fps, setFps] = useState(0);
  const frameCount = useRef(0);
  const lastTime = useRef(performance.now());

  useEffect(() => {
    if (!debugMode) return;

    let animationFrameId: number;

    const updateFPS = () => {
      frameCount.current++;
      const currentTime = performance.now();
      const elapsed = currentTime - lastTime.current;

      if (elapsed >= 1000) {
        setFps(Math.round((frameCount.current * 1000) / elapsed));
        frameCount.current = 0;
        lastTime.current = currentTime;
      }

      animationFrameId = requestAnimationFrame(updateFPS);
    };

    animationFrameId = requestAnimationFrame(updateFPS);

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [debugMode]);

  if (!debugMode) return null;

  const getFPSColor = () => {
    if (fps >= 55) return 'fps-good';
    if (fps >= 30) return 'fps-ok';
    return 'fps-bad';
  };

  return (
    <div className={`fps-counter ${getFPSColor()}`}>
      <span className="fps-value">{fps}</span>
      <span className="fps-label">FPS</span>
    </div>
  );
}
